import json from './sprite.js';

export default {
    handle: 'ENG_SPT12-ToyBox_225003055',
    label: 'en_SPT12-ToyBox_225003055',
    json,
};
